import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { CreditCardIcon } from "lucide-react";

const PaidAdsPage = () => {
  return (
    <div className="container mx-auto p-6">
      <Card className="border-blue-500/20">
        <CardHeader>
          <div className="flex items-center gap-4">
            <div className="p-3 rounded-xl bg-blue-500/10">
              <CreditCardIcon className="w-8 h-8 text-blue-500" />
            </div>
            <div>
              <h1 className="text-3xl font-bold gradient-text">
                Paid Ads
              </h1>
              <p className="text-muted-foreground">
                Meta, Google, and Twitter advertising strategies
              </p>
            </div>
          </div>
        </CardHeader>
        <CardContent className="flex flex-col items-center justify-center p-12 text-center">
          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-blue-500/20 blur-3xl" />
            <div className="relative space-y-4">
              <h2 className="text-2xl font-semibold">Coming Soon</h2>
              <p className="text-muted-foreground max-w-md">
                Learn how to create effective paid advertising campaigns across major platforms. Detailed guides and strategies coming soon.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaidAdsPage; 